// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608092329/js/" + chunkId + "." + {"44":"fb423e39","225":"f87341e1","481":"20420ecb","486":"38a427c7","770":"dced0e27"}[chunkId] + ".0.0983598039707938.chunk.js";
};